import type { LinkingMethod } from '../../useLinkingWorkflow';

/**
 * Método con el que el brazo de tratamiento abre el flujo, saltándose el
 * selector.
 *
 * El corte es el MISMO `isMobile` (`max-width: 768px`) con el que `useEvents`
 * estampa `source` en cada evento, para que "desktop" en el análisis signifique
 * exactamente `source = 'web'` y no haya dos definiciones que reconciliar.
 *
 * Desktop → e.firma: 9 de cada 10 que la eligen ahí llegan a adjuntar sus
 * archivos. Celular → RFC y contraseña: en celular el 46% de quienes eligen
 * e.firma se va sin enviar nada (no tienen el .cer y el .key en el teléfono)
 * contra 28% en RFC, y la conversión entre métodos empata dentro del mismo
 * dispositivo. Medido sobre los 30 días previos al 2026-08-27.
 */
export const resolveDirectMethod = (isMobile: boolean): LinkingMethod =>
	isMobile ? 'link' : 'efirma';
